import { useEffect, useRef } from 'react';

/**
 * useCamada — o comportamento de toda superfície por cima da tela (diálogo, gaveta, folha):
 * ao abrir, o foco vai para o primeiro controle; Esc fecha; ao fechar, o foco volta para
 * quem abriu. `onFechar` fica numa ref: a função do pai muda a cada render e não pode
 * reabrir o foco.
 */
export default function useCamada(aberto, onFechar, caixaRef) {
  const quemAbriu = useRef(null);
  const fecharRef = useRef(onFechar);
  fecharRef.current = onFechar;

  useEffect(() => {
    if (!aberto) return undefined;
    quemAbriu.current = document.activeElement;
    const primeiro = caixaRef.current?.querySelector('button, [href], input, select, textarea');
    primeiro?.focus();

    const aoApertarEsc = (e) => { if (e.key === 'Escape') fecharRef.current?.(); };
    document.addEventListener('keydown', aoApertarEsc);
    return () => {
      document.removeEventListener('keydown', aoApertarEsc);
      quemAbriu.current?.focus?.();
    };
  }, [aberto, caixaRef]);
}
